<script setup lang="ts">
    import type { PrimitiveProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import type { SidebarMenuButtonVariants } from '.';
    import { Primitive } from 'reka-ui';
    import { cn } from '../utils';
    import { sidebarMenuButtonVariants } from '.';

    export interface SidebarMenuButtonProps extends PrimitiveProps {
        variant?: SidebarMenuButtonVariants['variant'];
        size?: SidebarMenuButtonVariants['size'];
        isActive?: boolean;
        class?: HTMLAttributes['class'];
    }

    const props = withDefaults(defineProps<SidebarMenuButtonProps>(), {
        as: 'button',
        variant: 'default',
        size: 'default',
    });
</script>

<template>
    <Primitive
        data-slot="sidebar-menu-button"
        data-sidebar="menu-button"
        :data-size="size"
        :data-active="isActive"
        :class="cn(sidebarMenuButtonVariants({ variant, size }), props.class)"
        :as="props.as"
        :as-child="props.asChild"
        v-bind="$attrs"
    >
        <slot />
    </Primitive>
</template>
